import { navigationItems } from "./navigationItems.js";

export function MobileNavigation({
  id = "mobile-navigation",
  items = navigationItems,
} = {}) {
  const navigation = document.createElement("nav");
  const fragment = document.createDocumentFragment();

  navigation.className = "mobile-nav";
  navigation.id = id;
  navigation.setAttribute("aria-label", "Mobile navigation");
  navigation.setAttribute("aria-hidden", "true");
  navigation.inert = true;

  fragment.append(createDivider());

  items.forEach(({ label, href }) => {
    const link = document.createElement("a");

    link.className = "mobile-navlink";
    link.href = href;
    link.textContent = label;

    fragment.append(link, createDivider());
  });

  navigation.append(fragment);

  return navigation;
}

function createDivider() {
  const divider = document.createElement("div");

  divider.className = "nav-divider";
  divider.setAttribute("aria-hidden", "true");

  return divider;
}
